import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { AdminPanel } from './views/AdminPanel';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<AdminPanel />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.AdminPanel)
	.build();

export default Layout;
